export const STUDENT_CALENDAR = 'student.logged-in.calendar' as const;
export const STUDENT_CALENDAR_ENROLMENTS = `${STUDENT_CALENDAR}.enrolments` as const;
export const STUDENT_CALENDAR_ENROLMENTS_NOT_ENROLLED = `${STUDENT_CALENDAR}.not-enrolled` as const;
export const STUDENT_CALENDAR_ABORTED_AND_FINISHED = `${STUDENT_CALENDAR}.aborted-and-finished-enrolments` as const;
